<div class="signin-signup-container">
	<div class="left">
		<app-logo></app-logo>
	</div>

	<div class="right">
		<div class="app-title-container">
			<mat-icon svgIcon="login-icon" class="app-icon"></mat-icon>
			<span class="app-title">Strayos Analytics</span>
		</div>
		<div class="signin flex-column center">
			<div class="signin-container">
				<span class="login-title">Sign in to your Strayos Dashboards</span>
				<div class="login-title-divider"></div>

				<form class="flex-column" [formGroup]="loginForm" (ngSubmit)="onLogin()">
					<mat-form-field appearance="outline">
						<mat-label>Email</mat-label>
						<input matInput formControlName="email" type="email" placeholder="Enter email address">
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Password</mat-label>
						<input matInput formControlName="password" type="password" placeholder="Enter password">
					</mat-form-field>

					<div class="forgot-password">
						<a (click)="navigateToForgotPassword()">Forgot Password?</a>
					</div>

					<button mat-button class="login-button primary cta" type="submit" [disabled]="!loginForm.valid && !loggingIn">
						Log In
						<mat-spinner diameter="30" *ngIf="loggingIn"></mat-spinner>
					</button>

					<div class="separator">Or sign in with</div>

					<div class="sso-wrapper">
						<button type="button" class="sso-button" [disabled]="loggingIn" (click)="loginGoogle()">
							<mat-icon svgIcon="google-icon"></mat-icon>
							Sign in with Google
						</button>

						<button type="button" class="sso-button" [disabled]="loggingIn" (click)="loginMicrosoft()">
							<mat-icon svgIcon="microsoft-icon"></mat-icon>
							Sign in with Microsoft
						</button>
					</div>

					<div *ngIf="errorMessage" class="login-err">
						{{ errorMessage }}
					</div>
				</form>
			</div>
		</div>
	</div>
</div>